module.exports = __webpack_public_path__ + "static/img/icon_cloud5.22c8a5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud5.jpg
// module id = Ze2q
// module chunks = 21